// React hook for prefers-reduced-motion. Every animation in the mobile
// chrome — tab indicator slides, sheet transitions, tween counters,
// pill choreography — should fall back to instant for users who set
// this preference. Required for accessibility per WCAG 2.1, easy to
// skip if you're not deliberate about it.
//
// Usage:
//   const reduceMotion = useReducedMotion();
//   const transition = reduceMotion ? 'none' : 'transform 0.2s cubic-bezier(...)';
//
// SSR-safe: returns false during initial render on the server, then
// hydrates to the actual preference on mount.

import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const getMatch = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
};

export default function useReducedMotion() {
  const [reduce, setReduce] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const handler = (e) => setReduce(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduce;
}
